<sirius-container>
    <div class="sir-layout" [class.has-thumbnails]="hasThumbnails()">
        <div class="sir-media">
            <sirius-product-gallery
                [images]="media()"
                [imageData]="imageData"
                [thumbnailImageData]="thumbnailImageData"
                [statusLabel]="statusLabel()"
            ></sirius-product-gallery>
        </div>

        <div class="sir-content">
            @if (logo(); as logo) {
                <img class="sir-logo" [src]="logo.url" alt="" />
            }

            <div class="sir-text-group">
                @if (seriesLabels().length) {
                    <sirius-chips
                        [chips]="seriesLabels()"
                        ariaLabel="Product series"
                        data-cy="series-labels"
                    ></sirius-chips>
                }
                <sirius-heading
                    [text]="title()"
                    textStyleCategory="display"
                    textStyleSize="l"
                    [h]="1"
                    data-cy="title"
                ></sirius-heading>

                @if (ratings().length) {
                    <sirius-rating [ratings]="ratings()" data-cy="ratings"></sirius-rating>
                }
            </div>

            @if (subTitle() || textHtml()) {
                <div class="sir-text-group">
                    @if (subTitle()) {
                        <sirius-heading
                            [text]="subTitle()"
                            textStyleCategory="title"
                            textStyleSize="m"
                            [h]="2"
                            data-cy="subtitle"
                        >
                        </sirius-heading>
                    }
                    @if (textHtml()) {
                        <sirius-disclosure
                            variant="inline-clamp"
                            triggerPosition="below"
                            [clampLines]="descriptionMaxLines()"
                            [collapsedLabel]="'productHeader.readMore' | translate"
                            [expandedLabel]="'productHeader.readLess' | translate"
                            data-cy="read-more"
                        >
                            <sirius-text-html [html]="textHtml()"></sirius-text-html>
                        </sirius-disclosure>
                    }
                </div>
            }

            @if (hasButtons()) {
                <div class="sir-buttons" data-cy="buttons-container">
                    @if (buttonPrimary(); as primary) {
                        <a
                            siriusButton
                            [siriusLink]="primary.link"
                            [iconName]="primary.iconName"
                            [buttonText]="primary.link.title"
                            buttonType="primary"
                            size="large"
                            data-cy="primary-button"
                        >
                        </a>
                    }
                    @if (buttonSecondary(); as secondary) {
                        <a
                            siriusButton
                            [siriusLink]="secondary.link"
                            [iconName]="secondary.iconName"
                            [buttonText]="secondary.link.title"
                            buttonType="secondary"
                            size="large"
                            data-cy="secondary-button"
                        >
                        </a>
                    }
                </div>
            }

            @if (highlights(); as highlights) {
                @if (highlights.highlights.length) {
                    <sirius-highlight
                        class="product-header-highlights"
                        [config]="highlights"
                        data-cy="highlights"
                    ></sirius-highlight>
                }
            }
        </div>
    </div>
</sirius-container>
